export const storeModel = (currentStores) => {
    const newStores = currentStores?.map((currentStore) => {
        if (!currentStore) return {}

        const { store_id, brand, distance_unit, address, ...rest } = currentStore;

        return {
            ...rest,
            id: store_id,
            c_brand: brand,
            distanceUnit: distance_unit,
            address1: address.address1,
            city: address.city,
            stateCode: address.state_code,
            postalCode: address.postal_code,
            phone: address.phone
        }
    })

    return newStores;
}
